import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import {
  API_TYPE_ALERTS,
  API_TYPE_DASHBOARD,
  API_TYPE_EDR,
  API_TYPE_INTEGRITY_MONITOR_EVENTS,
  API_TYPE_ACCOUNTS,
  API_TYPE_QUARANTINE,
  API_TYPE_COMPANIES_FOR_GZ_TAGS,
  API_TYPE_PACKAGES,
  API_TYPE_EASM,
  API_TYPE_INTEGRATIONS_MARKETPLACE,
  API_TYPE_POLICY_EXCHANGE,
} from '../../../webcomponents.constants';
import { CompanyFilterNirvanaDataProvider } from '../dataProvider/CompanyFilterNirvanaDataProvider';
import { CompanyFilterQuarantineDataProvider } from '../dataProvider/CompanyFilterQuarantineDataProvider';
import { CompanyFilterEdrDataProvider } from '../dataProvider/CompanyFilterEdrDataProvider';
import { CompanyFilterAccountsDataProvider } from '../dataProvider/CompanyFilterAccountsDataProvider';
import { CompanyFilterIntegrityMonitorEventsDataProvider } from '../dataProvider/CompanyFilterIntegrityMonitorEventsDataProvider';
import { CompanyFilterGzTagsDataProvider } from '../dataProvider/CompanyFilterGzTagsDataProvider';
import { CompanyFilterPackagesDataProvider } from '../dataProvider/CompanyFilterPackagesDataProvider';
import { CompanyFilterEASMDataProvider } from '../dataProvider/CompanyFilterEASMDataProvider';
import {
  CompanyFilterIntegrationsMarketplaceDataProvider
} from "../dataProvider/CompanyFilterIntegrationsMarketplaceDataProvider";
import { CompanyFilterExchangeDataProvider } from '../dataProvider/CompanyFilterExchangeDataProvider';

export class CompanyFilterDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_PACKAGES, CompanyFilterPackagesDataProvider);
    this.map.set(API_TYPE_ALERTS, CompanyFilterNirvanaDataProvider);
    this.map.set(API_TYPE_QUARANTINE, CompanyFilterQuarantineDataProvider);
    this.map.set(API_TYPE_EDR, CompanyFilterEdrDataProvider);
    this.map.set(API_TYPE_ACCOUNTS, CompanyFilterAccountsDataProvider);
    this.map.set(API_TYPE_INTEGRITY_MONITOR_EVENTS, CompanyFilterIntegrityMonitorEventsDataProvider);
    this.map.set(API_TYPE_COMPANIES_FOR_GZ_TAGS, CompanyFilterGzTagsDataProvider);
    this.map.set(API_TYPE_EASM, CompanyFilterEASMDataProvider);
    this.map.set(API_TYPE_INTEGRATIONS_MARKETPLACE, CompanyFilterIntegrationsMarketplaceDataProvider);
    this.map.set(API_TYPE_POLICY_EXCHANGE, CompanyFilterExchangeDataProvider);
  }
}
